import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import BuildingKindsContent from './BuildingKindsContent';
import BuildingKindsModal from '../modals/BuildingKindsModal';

const form = {
  keyword: '',
};

function BuildingKindsContainer({
  match,
  history,
  getList,
  dataList,
  isLoading,
  dataListPager,
  showData,
  removeData,
  ordinanceRevisionId
}) {
  
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddKindModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingKindsModal type="NEW" ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Add Kind of Building',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingKindsModal dataInfo={data.attributes} id={data.id} type="EDIT" ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Update Kind of Building',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this kind of building?',
      () => {
        removeData(data.id, () => {
          getList();
          const id = _.get(dataList, '0.id');
          history.push(
            `/rpt/building/settings/building-kinds/${id}`
          );
          showData(id);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getList({
        name: formData.keyword,
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:buildingKindId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Kinds of Building"
            getData={getList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:buildingKindId?`}
            listName="buildingKinds"
            label="Kinds of Building"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
              </div>
            )}
            noRightCard
            isLoading={isLoading}
            selected={params.buildingKindId}
            data={dataList}
            dataPager={dataListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:buildingKindId?`}
                    render={() => (
                      <BuildingKindsContent
                        handleAddKindModal={handleAddKindModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        ordinanceRevisionId={ordinanceRevisionId}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:buildingKindId?`}
                  render={() =>
                    !params.buildingKindId && dataList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(dataList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BuildingKindsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  dataListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  removeData: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_BUILDING_KIND_LIST}.list`) || [],
  dataListPager: _.get(api, `${c.GET_BUILDING_KIND_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BUILDING_KIND_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingKindsContainer);
